import styled from 'styled-components'
import { darken } from 'polished'

export const Container = styled.div`
  ${({ theme }) => `

        text-align: right;
        display: flex;
        padding: 24px 0px;
        background-color: ${darken(0.05, theme['theme-color'])};
        a{
          width: 100%;
          text-align: center;
        }
 
    `};
`
